// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoInline_container__39b2g","script":"VideoInline_script__1pFet","imageContainer":"VideoInline_imageContainer__3mMrY"};